function getGraphemes({
  text,
  locale
}) {
  // returns undefined when Intl.Segmenter does not exist in our JS environment (such as in Firefox)
  if (!text || !Intl.Segmenter) {
    return undefined;
  }
  const segmenter = new Intl.Segmenter(locale, {
    granularity: 'grapheme'
  });
  return Array.from(segmenter.segment(text)).map(grapheme => grapheme.segment);
}

export { getGraphemes };
